import Vue from 'vue'
import date from './date'

Vue.mixin({
  ...date
})
